import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import Cbse from '../components/section/cbse';
 import config from '../constant';


class CbseMain extends Component {
    componentDidMount(){
        document.title = "School Docs | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <Cbse/>
             <Footer/>


        </div>
    );

}
    }
export default CbseMain;